export { default } from 'shared/components/context/main'
